import React, { useState, useEffect } from 'react';
import IconButton from '../../components/common/IconButton';
import { useDropzone } from 'react-dropzone';
import { startFileUploadToNextcloud } from '../actions/nextcloudActions';
import { connect } from 'react-redux';
import { instructionVersionsDataChanged } from '../actions/instuctionActions';
import deleteSection from './DeleteSection';
import { validateAttachmentName } from '../utils';
import { checkIsPDF, getDirectLink } from './utils';
import { ImageElement } from './OKNOKDropField/DropArea/Atom';

function Section ({ dispatch, section, versionIndex, dataIndex, disable, lastUsedAttachment }) {
  const instructionVersionsData = (value, field) => { dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, { ...section, [field]: value }))};
  // const instructionVersionsDataObj = (obj) => { dispatch(instructionVersionsDataChanged(versionIndex, dataIndex, { ...section, ...obj }))};

  const [title, setTitle] = useState('Example form');
  const [name, setName] = useState('');
  const [onDragOverState, setOnDragOverState] = useState(false);
  const [attachmentArrayLength, setAttachmentArrayLength] = useState(0);
  const [attachmentArray, setAttachmentArray] = useState([]);

  useEffect(() => {
    setAttachmentArrayLength(attachmentArray.length);
  }, [attachmentArray]);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    alert(`Submitting Name ${name}`);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    setOnDragOverState(true);
  };
  const onDragLeave = (e) => {
    e.preventDefault();
    setOnDragOverState(false);
  };

  const onDrop = (ev) => { //from widget

    // let url = ev.dataTransfer.getData('Text');
    const attachments = section.attachments;
    if(lastUsedAttachment.fullName.indexOf("pdf")=== -1) {//tutaj był url z eventu
      attachments.push({attachmentUrl: lastUsedAttachment.url, attachmentOriginalName: lastUsedAttachment.fullName});
    } else {
      //if is drop pdf file should recalculate url to great for download file
      attachments.push({attachmentUrl: lastUsedAttachment.url, attachmentOriginalName: lastUsedAttachment.fullName.split("/")[2]});
    }
    instructionVersionsData(attachments, "attachments")
    setOnDragOverState(false);
    setAttachmentArrayLength(attachments.length);
  };

  const deleteAttachment = (index) => {
    const tmp = section.attachments;
    tmp.splice(index, 1);
    // setAttachmentArray(tmp);
    instructionVersionsData(tmp, "attachments");
    setAttachmentArrayLength(tmp.length);
  };

  const handleDoubleClick = (event, index) => {
    if(disable) return;
    if (event.detail === 2) deleteAttachment(index)
  };

  const synchronizeWithNextcloud = ev => { dispatch(startFileUploadToNextcloud(ev)); };

  const addToPreview = (acceptedFiles) => {
    acceptedFiles.forEach((file, index) => {
      attachmentArray.push(URL.createObjectURL(file));
      setAttachmentArray(attachmentArray);
      setAttachmentArrayLength(attachmentArray.length);
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    disabled: disable,
    accept: 'image/*',
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      if(!validateAttachmentName(acceptedFiles)) return;
      const attachments = section.attachments;
      acceptedFiles.forEach(file => {
        attachments.push({attachmentUrl: URL.createObjectURL(file), attachmentOriginalName: file.name})
      });
      instructionVersionsData(attachments, "attachments")
      synchronizeWithNextcloud(acceptedFiles);
    },
  });

  return (
    <div style={{ border: '1px solid darkblue', margin: 5, padding: 10 }}>
      <form onSubmit={handleSubmit} style={{display: 'flex'}}>
        <div style={{ display: 'inline-block' }}>
          <h2><input disabled={disable} type="text" value={section.title} onChange={e => instructionVersionsData(e.target.value, "title")}/></h2>
          <textarea
            disabled={disable}
            style={{ width: 360, height: 70 }}
            value={section.description}
            onChange={e => instructionVersionsData(e.target.value, "description")}
          />
        </div>
        <div style={{ display: 'inline-block', padding: 20 }}>
          <div style={{ width: 120 }} {...getRootProps()}>
            <input {...getInputProps()}/>
            <IconButton
              disabled={disable}
              wide marginBottom title="Add attachment"
              onDragOver={(e) => {onDragOver(e);}}
              onDragLeave={(e) => {onDragLeave(e);}}
              onDrop={(e) => onDrop(e, 'complete')}
              onDrag={(event) => synchronizeWithNextcloud(event)}
              style={{ width: '90px', height: '90px' }}
            />
          </div>
        </div>

        <div style={{ display: 'inline-block' }}>
          <h2>Dodane załączniki: </h2>
          {section.attachments.map((el, index) => (
            <div style={{display: 'inline-block', alignItems: 'center', justifyContent: 'center', overflow: "hidden" }}>
              {checkIsPDF(el) && (
                <div style={{border: "1px solid grey", padding: "3px", margin: "5px"}}>
                  <span style={{display: "block", width: "100px"}}>{el.attachmentOriginalName}</span>
                  <a href={el.attachmentUrl} download onClick={(event)=>{event.stopPropagation()}} style={{display:"contents"}}>
                    <ImageElement
                      disabled={checkIsPDF(el)}
                      src={getDirectLink(el)}
                      alt={el.attachmentOriginalName}
                      style={{marginLeft: "auto", marginRight: "auto", maxHeight: 98, maxWidth: 178}}
                    />
                  </a>
                  {!disable && (<span onClick={() => deleteAttachment(index)} style={{cursor: "pointer", display: "inline", position: "absolute"}}>X</span>)}
                </div>
              )}
              {!checkIsPDF(el) && (
                <div style={{border: '1px solid black', padding: "3px", margin: "5px"}}>
                  <img src={el.attachmentUrl} alt="" style={{ maxHeight: 98, maxWidth: 178 }}
                   onClick={(ev) => handleDoubleClick(ev, index)}/>
                  <a href={el.attachmentUrl} target="_blank" style={{display: 'block'}}>Open in new tab!</a>
                </div>
              )}
            </div>
          ))}
        </div>
        {/*<input type="submit" value="Submit"/>*/}
      </form>
    </div>
  );
}

const mapStateToProps = ({ filesWidgetReducer, instructionsReducer }) => {
  return {
    lastUsedAttachment: filesWidgetReducer.lastUsedAttachment,
    versions: instructionsReducer.versions
  }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};
export const SectionWithoutDeleteButton = connect(mapStateToProps, mapDispatchToProps)(Section);
export default connect(mapStateToProps, mapDispatchToProps)(deleteSection(Section));
